import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { DeviceKind } from "./TeamDashboard";

// Тип устройства: планшеты — вместе с телефонами.
export const DEVICE_LABELS: Record<DeviceKind, MessageDescriptor> = {
  mobile: msg`Phone`,
  desktop: msg`Computer`,
};
